import SaveExtra from "../../services/general/saveExtraData.api"

 
export const callPatientStatusApi = async (type, data , id) => {
  try {
    const res = await SaveExtra(
      type,  
      'CheckForUpdates',
      JSON.stringify(data),
      id
    )
    return res
  } catch (err) {
    console.error('API Error:', err)
  }
}

 

export const fetchCheckForUpdate = async () => {
  try {
    const res = await SaveExtra(
      'Get_By_Type',
      'CheckForUpdates',
      '',
      ''
    )

    let parsed = JSON.parse(res?.d || '{}')?.Data || {}

    console.log("fetch data",parsed)
     let filterData
       if(parsed && parsed.length > 0){
         filterData = parsed?.map((item,index)=>({...item, JsonData:  JSON.parse(item?.JsonData)}))
       }

    return filterData 
  } catch (err) {
    console.error('Fetch Error:', err)
    return {}
  }
}

export const fetchCheckForUpdateTodaysData = async (id) => {
  try {
    const res = await SaveExtra(
      'Get_By_Type',
      'CheckForUpdates',
      '',
      id
    )

    let parsed = JSON.parse(res?.d || '{}')?.Data || {}
     let filterData
       if(parsed && parsed.length > 0){
         filterData = parsed?.map((item,index)=>({...item, JsonData:  JSON.parse(item?.JsonData)}))
       }

    return filterData 

 
  } catch (err) {
    console.error('Fetch Error:', err)
    return {}
  }
}

